const apiPaths = {
    token: "185Hcomic3PAPP7R",

    // APP 設定
    API_APP_SETTING: "setting",

    // 新廣告
    API_ADVERTISE_ALL: "ad_content_all",
    API_ADVERTISE_CONTENT_COVER: "advertise_all",

    //小說
    API_NOVEL_LIST: "novels",
    API_NOVEL_DETAIL: "novel",
    API_NOVEL_CHAPTERS: "novelchapters",
    API_NOVEL_SEARCH: "search_novels",
    API_NOVEL_LIKE: "like",
    API_NOVEL_COMMENT: "comment",
    API_NOVEL_FAVORITES: "novel_favorites",
    API_EDIT_NOVEL_FAVORITES: "novel_favorites_folder",
    API_NOVEL_COIN_BUY: "coin_buy_nc",

    // 搜尋
    API_COMIC_SEARCH: "search",
    API_COMIC_HOT_TAGS: "hot_tags",
    API_COMIC_RANDOM_RECOMMEND: "random_recommend",

    // 首頁
    API_COMIC_PROMOTE: "promote",
    API_COMIC_LATEST: "latest",

    // 首頁 -> 更多
    API_COMIC_PROMOTE_LIST: "promote_list",
    API_COMIC_SER_MORE_LIST: "serialization",

    // 漫畫章節
    API_COMIC_CHAPTER: "chapter",
    API_COMIC_DETAIL: "album",
    API_COMIC_READ: "comic_read",

    // 會員資料
    API_MEMBER_LOGIN: "login",
    API_MEMBER_LOOUT: "logout",
    API_MEMBER_REGISTER: "register",
    API_MEMBER_FORGOT: "forgot",

    // 分類
    API_CATEGORIES_LIST: "categories",
    API_CATEGORIES_FILTER_LIST: "categories/filter",

    // 論壇留言
    API_FORUM_LIST: "forum",
    API_COMMENT_SEND: "comment",
    API_COMMENT_VOTE: "comment_vote",
    API_COMMENT_DETELE: "comment_delete",
    API_CHECK_RECOMMEND_BN: "check_recommend_book",

    // 我的收藏
    API_FAVORITE_LIST: "favorite",
    API_LIKE_DATA: "like",

    // 觀看歷史
    API_HISTORY_LIST: "watch_list",

    // 遊戲
    API_GAMES_LIST: "allgames",

    // 影片
    API_VIDEOS_LIST: "videos",
    API_LATEST_HANIME: "latest_hanime",
    API_VIDEO_INFO: "video",
    API_BAITU_CREATE_TOKEN: "baitu-create-token",

    // 部落格
    API_BLOGS_LIST: "blogs",
    API_BLOG_INFO: "blog",
    API_GAME_INFO: "game",

    // 收藏資料夾編輯
    API_FAVORITE_FOLDER: "favorite_folder",

    // 成就系統
    API_TASKS_LIST: "tasks",
    API_TASKS_BUY_LIST: "coin",

    // 回傳錯誤資訊
    API_ERROR_LOG: "error_log",

    // 每週必看
    API_WEEK: "week",
    API_WEEK__FILTER_LIST: "week/filter",

    // 下載頁
    API_ALBUM_DOWNLOAD: "album_download_2",

    // 使用者編輯
    API_USEREDIT: "useredit",

    // 廣告banner
    API_ADVERTISE: "advertise",
    API_ADVERTISE_CONTENT: "ad_content",

    // 簽到
    API_DAILY: "daily",
    API_DAILY_CHECK: "daily_chk",
    API_DAILY_LIST: "daily_list",
    API_DAILY_LIST_FILTER: "daily_list/filter",

    // tag 收藏
    API_TAGS_FAVORITE: "tags_favorite",
    API_TAGS_FAVORITE_UPDATE: "tags_favorite_update",

    // 購買ai漫畫
    API_COIN_BUY_COMICS: "coin_buy_comics",

    // 購買充能
    API_COIN_BUY_CHARGE: "coin_buy_charge",

    // 開啟去廣告
    API_AD_FREE: "ad_free",

    // 通知
    API_NOTIFICATIONS: "notifications",
    API_NOTIFICATIONS_UNREAD: "notifications/unreadCount",
    API_NOTIFICATIONS_SERTRACK: "album_sertracking",
    API_NOTIFICATIONS_TRACK_LIST: "album_tracking",

    // 書庫
    API_CREATOR_AUTHOR: "creator_author",
    API_CREATOR_WORK: "creator_work",
    API_CREATOR_WORK_DETAIL: "creator_author_work",
    API_CREATOR_WORK_INFO: "creator_work_info",
    API_CREATOR_WORK_INFO_DETAIL: "creator_work_info_detail",
};

export default apiPaths;
